
'use client';

import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

export default function useCheckLogin() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const id = Cookies.get('id');
        setIsLoggedIn(!!id);
    }, []);

    return isLoggedIn;
}

